export default __webpack_public_path__ + "static/media/cursos_en_linea.bade5431.svg";